import { BehaviorSubject } from 'rxjs';

export const branch$ = new BehaviorSubject<string | undefined>(undefined);
export const siteTitle$ = new BehaviorSubject<string | undefined>(undefined);

type TitleState = {
    branch?: string;
    siteTitle?: string;
};

export function initializeTitleState({ branch, siteTitle }: TitleState): void {
    branch$.next(branch);
    siteTitle$.next(siteTitle);
}
